module.exports = __webpack_public_path__ + "static/current_access-1e71e476cdfa0d8ed05d6678d2098ccd.png";